import { getComponentFromName } from '@folklore/utils';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';

import useCategories from '../../hooks/useCategories';

import * as CardComponents from '../cards/taxonomies';
import PresentationList, { PresentationListProps } from './PresentationList';

const hooks = {
    default: useCategories,
};

interface CategoriesListProps extends Omit<
    PresentationListProps<Category>,
    'cardComponent' | 'hook'
> {
    hook?: string | null;
    cardComponent?: ElementType | null;
    cardType?: string | null;
}

function CategoriesList({
    hook = 'default',
    cardType,
    cardComponent,
    ...props
}: CategoriesListProps) {
    return (
        <PresentationList<Category>
            hook={isString(hook) ? hooks[hook] || hooks.default : hook}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, CardComponents.Horizontal)
            }
        />
    );
}

export default CategoriesList;
